<script>
import axios from "axios";
import { GravyPath } from "../../../../../../path";
import Swal from "sweetalert2";

export default {
  props: ["items_data", "mainOrder"],
  data() {
    return {
      currentPage: 1,
      fields: ["item", "qty_returned", "qty_accepted"],
      items: [],
      type: "gravy",
      base_url: process.env.VUE_APP_API_BACKEND_URL,
    };
  },
  methods: {
    async moveToAccepted() {
      let gravies = [];
      let packagings = [];
      this.items.forEach((item) => {
        if (item.gravy_id) {
          gravies.push({
            id: item.gravy_id,
            qty_confirmed: item.qty_returned_confirmed,
            qty_confirmed_pcs: item.qty_returned_confirmed_pcs,
          });
        } else {
          packagings.push({
            id: item.packaging_id,
            qty_confirmed: item.qty_returned_confirmed,
            qty_confirmed_pcs: item.qty_returned_confirmed_pcs,
          });
        }
      });
      try {
        let res = await axios.post(
          this.base_url + GravyPath.ORDERS.GRAVY_RETURN_MARK_ACCEPTED,
          {
            id: this.mainOrder.id,
            gravies,
            packagings,
          }
        );
        if (res.data.status) {
          if (res.data.status) {
            Swal.fire("Created Successfully", "", "success");
            this.$bvModal.hide("edit-items");
            this.$emit("reload");
          } else {
            Swal.fire("Failed to create", "", "error");
          }
        }
      } catch (err) {
        console.log(err);
      }
    },
  },
  mounted() {
    this.items = this.items_data;
    console.log(this.items, "ii");
  },
};
</script>

<template>
  <b-card>
    <b-card-body>
      <b-tabs>
        <b-tab title="Gravy" @click="() => (type = 'gravy')"></b-tab>
        <b-tab title="Packaging" @click="() => (type = 'packaging')"></b-tab>
      </b-tabs>
      <b-table
        :key="2"
        responsive="sm"
        :items="
          items.filter((f) =>
            type == 'gravy' ? f.gravy != null : f.packaging != null
          )
        "
        :fields="fields"
        :current-page="currentPage"
        :per-page="10"
      >
        <template v-slot:cell(item)="row">
          <p>
            {{
              row.item.gravy != null
                ? row.item.gravy.name
                : row.item.packaging.name
            }}
          </p>
        </template>
        <template v-slot:cell(qty_returned)="row">
          <span>{{ row.item.qty_returned }} pkts</span>
          <span v-if="row.item.qty_returned_pcs">
            + {{ row.item.qty_returned_pcs }} pcs</span
          >
        </template>
        <template v-slot:cell(qty_accepted)="row">
          <div style="display: flex; flex-direction: column; gap: 4px">
            <div style="display: flex; align-items: center; gap: 4px">
              <b-input-group style="width: 130px">
                <b-input-group-prepend>
                  <b-button
                    @click="row.item.qty_returned_confirmed--"
                    size="sm"
                    variant="primary"
                    :disabled="row.item.qty_returned_confirmed == 0"
                    ><i class="fa fa-minus"></i
                  ></b-button>
                </b-input-group-prepend>
                <b-form-input
                  type="number"
                  :key="row.item.id"
                  :value="
                    row.item.qty_returned_confirmed == 0
                      ? row.item.qty_returned
                      : row.item.qty_returned_confirmed
                  "
                  v-model="row.item.qty_returned_confirmed"
                  min="0"
                ></b-form-input>
                <b-input-group-append>
                  <b-button
                    @click="row.item.qty_returned_confirmed++"
                    size="sm"
                    variant="primary"
                    :disabled="
                      row.item.qty_returned_confirmed == row.item.qty_returned
                    "
                    ><i class="fa fa-plus"></i
                  ></b-button>
                </b-input-group-append>
              </b-input-group>
              <span>Pkts</span>
            </div>
            <div
              style="display: flex; align-items: center; gap: 4px"
              v-if="row.item.qty_returned_pcs"
            >
              <b-input-group style="width: 130px">
                <b-input-group-prepend>
                  <b-button
                    @click="row.item.qty_returned_confirmed_pcs--"
                    size="sm"
                    variant="primary"
                    :disabled="row.item.qty_returned_confirmed_pcs == 0"
                    ><i class="fa fa-minus"></i
                  ></b-button>
                </b-input-group-prepend>
                <!-- {{row.item.qty_returned_confirmed}} -->
                <b-form-input
                  type="number"
                  :key="row.item.id"
                  :value="
                    row.item.qty_returned_confirmed_pcs == 0
                      ? row.item.qty_returned_pcs
                      : row.item.qty_returned_confirmed_pcs
                  "
                  v-model="row.item.qty_returned_confirmed_pcs"
                  min="0"
                ></b-form-input>
                <b-input-group-append>
                  <b-button
                    @click="row.item.qty_returned_confirmed_pcs++"
                    size="sm"
                    variant="primary"
                    :disabled="
                      row.item.qty_returned_confirmed_pcs ==
                      row.item.qty_returned_pcs
                    "
                    ><i class="fa fa-plus"></i
                  ></b-button>
                </b-input-group-append>
              </b-input-group>
              <span>pcs</span>
            </div>
            <div v-if="row.item.qty_returned_pcs">
              <span
                >Total :
                {{
                  parseInt(row.item.qty_returned_confirmed) +
                  parseInt(row.item.qty_returned_confirmed_pcs) /
                    parseInt(
                      row.item.gravy_id ? row.item.gravy.uom : row.item.units
                    )
                }}
                pkts
              </span>
            </div>
          </div>
        </template>
      </b-table>
      <div class="row">
        <div class="col">
          <div class="dataTables_paginate paging_simple_numbers float-right">
            <ul class="pagination pagination-rounded mb-0">
              <b-pagination
                :key="1"
                v-model="currentPage"
                :total-rows="items.length"
                :per-page="10"
              ></b-pagination>
            </ul>
          </div>
        </div>
      </div>
      <b-row>
        <b-col>
          <b-button @click="moveToAccepted()">Move to Accepted</b-button>
        </b-col>
      </b-row>
    </b-card-body>
  </b-card>
</template>

<style></style>
